import React, { useEffect } from "react";
import { WithHostUrl } from "@quintype/components";

import { getHeaderUrl } from "./utils";

export const useStyleMenubar = isVerticalMenubar => {
  useEffect(() => {
    const element = document.getElementsByTagName("body")[0];
    element.style.overflow = isVerticalMenubar ? "hidden" : "";
  }, [isVerticalMenubar]);
};

export const useDeviceWidth = setIsDesktop => {
  useEffect(() => {
    if (global.deviceWidth >= 876) {
      setIsDesktop(true);
    }
  }, []);
};

export const logoRenderer = (children, currentPath) => (
  <WithHostUrl>
    {({ currentHostUrl }) => {
      const hostUrl = () => {
        if (currentPath) {
          return getHeaderUrl(currentPath);
        } else if (currentHostUrl) {
          return currentHostUrl + "/";
        } else return "/";
      };

      return <a href={hostUrl()}>{children}</a>;
    }}
  </WithHostUrl>
);
